import React from "react";

export const AcademicCouncil = () => {
  return (
    <section id="council" className="py-12 md:py-16 font-montserrat">
      <div className="container mx-auto px-4 max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-8">
          УЧЕБНО-МЕТОДИЧЕСКИЙ СОВЕТ
        </h2>
        <h3 className="text-2xl font-semibold text-gray-800 mb-5 border-t pt-6 text-left ">
          Состав учебно-методического совета:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-5 justify-around mb-10 text-center md:text-left">
          <div>
            <p className="text-sm font-semibold text-blue-700 uppercase tracking-wide">
              Председатель
            </p>
            <p className="text-xl font-medium text-gray-800">
              Шарипбаева Бибигуль Баяновна
            </p>
            <p className="text-gray-600">Методист</p>
          </div>

          <div>
            <p className="text-sm font-semibold text-blue-700 uppercase tracking-wide">
              Заместитель председателя
            </p>
            <p className="text-xl font-medium text-gray-800">
              Қанатова Жұлдыз Ерсайынқызы
            </p>
            <p className="text-gray-600">Главный менеджер</p>
          </div>

          <div>
            <p className="text-sm font-semibold text-blue-700 uppercase tracking-wide">
              Секретарь
            </p>
            <p className="text-xl font-medium text-gray-800">
              Ермекбаева Аида Талгатовна
            </p>
            <p className="text-gray-600">Менеджер</p>
          </div>
        </div>
        <div>
          <h3 className="text-2xl font-semibold text-gray-800 mb-5 border-t pt-6 text-center md:text-left">
            Члены учебно-методического совета:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-5">
            {[
              {
                name: "Керимбаева Эльмира Саметовна",
                title: "Исполнительный директор по реализации услуг",
              },
              {
                name: "Оспанова Анар Капаровна",
                title: "Руководитель проектного офиса по услугам",
              },
              {
                name: "Саулембеков Амирхан Рзаханович",
                title: "Координатор проектных программ МОФ «БІЛІМ-ИННОВАЦИЯ»",
              },
              {
                name: "Жумагул Жаслан Баксиикулы",
                title: "Координатор проектов, МОФ «БІЛІМ-ИННОВАЦИЯ»",
              },
              { name: "Кабдуалиев Рамиль", title: "Директор ТОО «Ustaz.Pro»" },
            ].map((member, index) => (
              <div key={index}>
                <p className="font-medium text-gray-800">{member.name}</p>
                <p className="text-sm text-gray-600">{member.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AcademicCouncil;
